export function Dashboard() {
  return (
    <div className="w-full h-[100px] border text-center text-white text-2xl">
      Here&apos;s a Dashboard
    </div>
  );
}
